export type IntegrationTableColumn = {
  key: string;
  label: string;
};

export const technologyToSlug = (technology: string): string =>
  technology
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

/** Partner project technology names may include variants (e.g. "Apple Wallet - Corporate"). */
export const partnerTechnologyMatchesColumn = (
  partnerTechnology: string,
  columnLabel: string
): boolean => {
  const partner = partnerTechnology.toLowerCase().trim();
  const column = columnLabel.toLowerCase().trim();

  return (
    partner === column ||
    partner.startsWith(`${column} `) ||
    partner.startsWith(`${column}-`)
  );
};

export const mapTableColumnsFromTechnologies = (
  technologies: string[]
): IntegrationTableColumn[] =>
  technologies.map((technology) => ({
    key: technologyToSlug(technology),
    label: technology,
  }));

export const formatIntegrationColumnLabel = (
  key: string,
  columns: IntegrationTableColumn[]
): string => columns.find((col) => col.key === key)?.label ?? key;

export const getColumnKeys = (columns: IntegrationTableColumn[]): string[] =>
  columns.map((col) => col.key);

/** Keep the full column set when search responses return a subset of technologies. */
export const mergeTableColumns = (
  existing: IntegrationTableColumn[],
  incoming: IntegrationTableColumn[]
): IntegrationTableColumn[] => {
  if (existing.length === 0) return incoming;
  if (incoming.length === 0) return existing;

  const incomingByKey = new Map(incoming.map((col) => [col.key, col]));
  const merged = existing.map((col) => incomingByKey.get(col.key) ?? col);

  incoming.forEach((col) => {
    if (!merged.some((existingCol) => existingCol.key === col.key)) {
      merged.push(col);
    }
  });

  return merged;
};
